import HttpService from './httpService';
import config from '../../config';

class IntercambioApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async generarXML({ headquarter, evaluaciones, ano, grado, ccodclis }) {
    return this.post(
      'generarXML',
      { ccodclis },
      { params: { headquarter, evaluaciones, ano, grado } },
    );
  }

  async exportToXML({ headquarter, evaluaciones, ano, grado, ccodclis }) {
    return this.post(
      'exportToXML',
      { ccodclis },
      { params: { headquarter, evaluaciones, ano, grado } },
    );
  }

  async buscarAlumnosServeiIntercanvi({ headquarter, ano, grado }) {
    return this.get('buscarAlumnosServeiIntercanvi', {
      params: { headquarter, ano, grado },
    });
  }
}

const intercambioApiService = new IntercambioApiService(config.REACT_APP_NODE_API);
export default intercambioApiService;
